<app-topnav></app-topnav>

<!-- HEADER -->
<app-header-secondary-h [pageTitle]="'Pluriportail<sup>&reg;</sup> Mobile'" 
    [pageDescription]="['La communication entre l’école et la maison', 'n’importe où, n’importe quand']"
    [imageURL]="'assets/img/logiciels/PPM_top.png'" *ngIf="currentLang ==='fr'"></app-header-secondary-h>
<app-header-secondary-h [pageTitle]="'Pluriportail<sup>&reg;</sup> Mobile'" 
    [pageDescription]="['Effective communication between school and home', 'from anywhere and at any time']"
    [imageURL]="'assets/img/logiciels/PPM_top.png'" *ngIf="currentLang ==='en'"></app-header-secondary-h>
<!-- end HEADER -->

    <!-- SECTION characteristics -->
    <section id="section-characteristics">
        <div id="section-characteristics-inner">
            <div class="container">
                <div class="row">
                    <div class="col col-12" *ngIf="currentLang ==='fr'">
                        <h2 class="section-title">
                            <strong>Caractéristiques et avantages</strong>
                        </h2>
                        <p>Pluriportail Mobile est le compagnon pédagogique indispensable pour les gestionnaires et les familles. Tous les intervenants peuvent prendre l’élève en charge en temps réel. L’application mobile scolaire la plus complète au Québec est disponible sur Apple, Android et Windows en mode connecté ou hors ligne. Au bout de vos doigts : agenda, travaux, contenus de cours, absences et comportements.</p>
                    </div>
                    <div class="col col-12" *ngIf="currentLang ==='en'">
                        <h2 class="section-title">
                            <strong>Benefits and key features</strong>
                        </h2>
                        <p>The Mobile Pluriportail is the essential educational partner for managers and families. All the interveners are allowed to get involved with any student in real time. This school mobile app is the most comprehensive available in Quebec and is offered on Apple, Google and Windows, in on/off line mode. At your fingertips: agenda, assignments, contents of courses, absences and behaviour notices.</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col col-12 col-md-6">
                        <div class="row">
                            <div class="col-md-6">
                                <img src="assets/img/pages/characteristics_01.svg" />
                            </div>
                            <div class="col-md-6">
                                <div class="content">
                                    <p *ngIf="currentLang ==='fr'">À la disposition de tous : les agendas synchronisés, comprenant les travaux et contenus de cours.</p>
                                    <p *ngIf="currentLang ==='en'">At everyone’s disposal: synchronized agendas, including assignments and course contents.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col col-12 col-md-6">
                        <div class="row">
                            <div class="col-md-6">
                                <img src="assets/img/pages/characteristics_02.svg" />
                            </div>
                            <div class="col-md-6">
                                <div class="content">
                                    <p *ngIf="currentLang ==='fr'">Communication accrue entre intervenants, parents et élèves avec la messagerie privée et intégrée </p>
                                    <p *ngIf="currentLang ==='en'">Improved communication between interveners, parents and students thanks to the integrated private mailbox.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col col-12 col-md-6">
                        <div class="row">
                            <div class="col-md-6">
                                <img src="assets/img/pages/characteristics_03.svg" />
                            </div>
                            <div class="col-md-6">
                                <div class="content">
                                    <p *ngIf="currentLang ==='fr'">Diffusion en un seul clic de communiqués de tous genres : sorties, fermeture d’école, etc.</p>
                                    <p *ngIf="currentLang ==='en'">One-click posting of all kinds of notices, school outings, school closure, etc.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col col-12 col-md-6">
                        <div class="row">
                            <div class="col-md-6">
                                <img src="assets/img/pages/characteristics_04.svg" />
                            </div>
                            <div class="col-md-6">
                                <div class="content">
                                    <p *ngIf="currentLang ==='fr'">Suivi assidu avec les commentaires sur le comportement des élèves, la motivation des absences et retards, etc.</p>
                                    <p *ngIf="currentLang ==='en'">Diligent monitoring, with comments about the students’ behaviour, motivated absences, lateness, and more.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
    <!-- end SECTION characteristics -->

    <!-- SECTION - taquets -->
    <app-taquets *ngIf="currentLang ==='fr'" #ref [title]="taquets.title" [description]="taquets.description" [items]="taquets.items">
        <div class="taquets-slides">
            <div class="taquets-slide" [class.active]="ref.selected === 0">

                <h2 class="section-title"><strong>Enseignants</strong></h2>
                <p>Vos élèves n’auront plus d’excuse! En publiant les travaux, contenus de cours, dates d’examens et de remise des travaux sur le Pluriportail, etc., les élèves voient leur chance de se responsabiliser augmenter grandement… d’autant plus que leurs parents ont également accès à vos publications, et ce, à la maison avec une connexion Internet ou ailleurs sans connexion! De plus, l’outil vous permet d’effectuer la prise de présences et de retards et de commenter les comportements des élèves en temps réel.</p>
                        
            </div>
            <div class="taquets-slide" [class.active]="ref.selected === 1">

                <h2 class="section-title"><strong>Parents</strong></h2>
                <p>L’implication des parents dans le cheminement scolaire de leur enfant est primordiale. Le Pluriportail mobile leur permet de consulter les comportements, de motiver les absences ou les retards et de communiquer par messagerie avec les intervenants de l’école. De plus, cet outil technologique novateur contient l’agenda complet de l’enfant, incluant ses travaux et le contenu de ses cours. En exclusivité sur le Pluriportail mobile : la géolocalisation. En activant cette fonction, les parents ont la possibilité d’annoncer automatiquement leur arrivée imminente au service de garde de l’école afin que l’enfant soit prêt.</p>

            </div>
            <div class="taquets-slide" [class.active]="ref.selected === 2">

                <h2 class="section-title"><strong>Élèves</strong></h2>
                <p>Leur sac d’école entre maintenant dans leur poche. À l’aide d’un téléphone intelligent, les élèves ont accès à leur horaire, les travaux et examens ainsi qu’à la charge de travail exigée. Les contenus de cours et les vidéos qui s’y rattachent sont visibles ainsi que les documents que les enseignants déposent pour eux. C’est l’endroit idéal pour écrire au personnel de l’école, prendre des notes personnelles et accéder aux contacts importants.</p>

            </div>
            <div class="taquets-slide" [class.active]="ref.selected === 3">

                <h2 class="section-title"><strong>Gestionnaires</strong></h2>
                <p>Finis les billets égarés ! Vous êtes en mesure d’assigner des comportements aux élèves à tout moment, peu importe où vous êtes. Les parents, quant à eux, peuvent signer électroniquement vos billets de comportement. Prendre les présences en classe ou lors des activités est tellement plus facile et efficace à partir de votre appareil mobile, connecté à Internet ou non. Quoi de plus pratique que d’avoir accès aux dossiers des élèves ainsi qu’aux allergies, et ce, à même votre portable ou votre cellulaire ?</p>

            </div>
            
        </div>
    </app-taquets>
    <app-taquets *ngIf="currentLang ==='en'" #ref [title]="taquets.titleEN" [description]="taquets.descriptionEN" [items]="taquets.itemsEN">
        <div class="taquets-slides">
            <div class="taquets-slide" [class.active]="ref.selected === 0">

                <h2 class="section-title"><strong>Teachers</strong></h2>
                <p>No more excuses for homework not done! By posting on the Pluriportail the subjects and contents of your courses, along with the various assignments and their due dates, as well as examination dates, you make it almost impossible for your students to wash their hands of their responsibilities. Especially when the parents also have access to your posts, at home on Internet, or elsewhere even without any wi-fi connection! Moreover, this tool enables you to take attendance in class and report late arrivals, as well as to comment about the children’s behaviour in real time.</p>
                        
            </div>
            <div class="taquets-slide" [class.active]="ref.selected === 1">

                <h2 class="section-title"><strong>Parents</strong></h2>
                <p>Parents’ involvement in the children educational pathway is of the utmost importance. The mobile Pluriportail allows them to consult notes about behaviour, to motivate their child’s absence or late arrival, and to communicate by mailbox with the various school staff members. This innovative tool also contains the complete agenda of the child, including his assignments and the contents of his courses. This efficient mobile app also offers an exclusive geo-tracking functionality. By activating this function, parents can also automatically announce their imminent arrival at the school child care service. No more time lost waiting for your kids to get ready!</p>

            </div>
            <div class="taquets-slide" [class.active]="ref.selected === 2">

                <h2 class="section-title"><strong>Students</strong></h2>
                <p>Their schoolbag now fits in their pocket. On their smartphone, students have direct access to their schedule, their assignments and examination details, as well as to the required workload. The courses contents and related videos are easy to read, as are all the documents posted by the teachers to the students. This is the best point of contact to write to the school staff, to take personal notes and to have access to important contacts.</p>

            </div>
            <div class="taquets-slide" [class.active]="ref.selected === 3">

                <h2 class="section-title"><strong>Managers</strong></h2>
                <p>No more lost notices to parents! You can register students’ behaviour-related notes at any time, where ever you are. Moreover, the parents can even put their electronical signature on our behaviour notices. To take attendance in classroom, or during a special activity, is much easier and efficient when done from your mobile device, connected to internet or not! What could be more convenient than having direct access to the students’ records, know about the children’s particular allergies, and this, from your laptop or your smartphone?</p>

            </div>
            
        </div>
    </app-taquets>
    <!-- end SECTION - taquets -->
    
    <!-- SECTION - apps -->

    <section id="section-characteristics">
        <div id="section-characteristics-inner">
            <div class="container">
                <div class="row">
                    <div class="col col-12" *ngIf="currentLang ==='fr'">
                        <h2 class="section-title">
                            <strong>Disponible sur plusieurs plateformes</strong>
                        </h2>
                        <p>Le Pluriportail Mobile est disponible sur les boutiques d'applications suivantes :</p>
                    
                    </div>
                    <div class="col col-12" *ngIf="currentLang ==='en'">
                        <h2 class="section-title">
                            <strong>Available on multiple platforms</strong>
                        </h2>
                        <p>The Pluriportail Mobile is available on the following application stores:</p>
                    </div>
                    
                </div>

                <div class="appsStores" *ngIf="currentLang ==='fr'">
                    <div class="item"><a href="https://play.google.com/store/apps/details?id=com.plurilogic.pp2m" target="_blank"><img src="assets/img/logiciels/Apps/googlestore.png"></a></div>
                    <div class="item"><a href="http://itunes.apple.com/ca/app/pluriportail-mobile/id996956624?at=10lITx&mt=8" target="_blank"><img src="assets/img/logiciels/Apps/applestore.png"></a></div>
                    <div class="item"><a href="https://www.amazon.ca/gp/product/B09FRD16Z5/ref=Pluriportail_mobile" target="_blank"><img src="assets/img/logiciels/Apps/amazonstore.png"></a></div>
                    <div class="item"><a href="https://www.plurilogic.com/Pluricommunaute/PluriportailMobile/VersionWindowsetIOS.html" target="_blank"><img src="assets/img/logiciels/Apps/windowsstore.png"></a></div>
                </div>

                <div class="appsStores" *ngIf="currentLang ==='en'">
                    <div class="item"><a href="https://play.google.com/store/apps/details?id=com.plurilogic.pp2m" target="_blank"><img src="assets/img/logiciels/Apps/googlestore_en.png"></a></div>
                    <div class="item"><a href="http://itunes.apple.com/ca/app/pluriportail-mobile/id996956624?at=10lITx&mt=8" target="_blank"><img src="assets/img/logiciels/Apps/applestore_en.png"></a></div>
                    <div class="item"><a href="https://www.amazon.ca/gp/product/B09FRD16Z5/ref=Pluriportail_mobile" target="_blank"><img src="assets/img/logiciels/Apps/amazonstore_en.png"></a></div>
                    <div class="item"><a href="https://www.plurilogic.com/Pluricommunaute/PluriportailMobile/VersionWindowsetIOS.html" target="_blank"><img src="assets/img/logiciels/Apps/windowsstore_en.png"></a></div>
                </div>

            </div>
        </div>
    </section>



    <!-- end SECTION - apps -->

    <p>&nbsp;</p>
    <p>&nbsp;</p>

<app-footer></app-footer>
